import  Swal  from 'sweetalert2';
import { AuthService } from 'src/app/_services/auth.service';
import { UserService } from 'src/app/_services/user.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgotten-password-input',
  templateUrl: './forgotten-password-input.component.html',
  styleUrls: ['./forgotten-password-input.component.css']
})
export class ForgottenPasswordInputComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  responseMessage = '';
  errorEncountered=false

  isRegistrationSuccess=false
  email=""


  constructor(
      private formBuilder: FormBuilder,
      private router: Router,
      private authService:AuthService,
      private userService:UserService

  ) {
    this.authService.gatePass.subscribe(
      value=>{
        if (value.is_logged_in) {
          this.router.navigate(['/']);
      }
      }
    )
  }

  ngOnInit() {
      this.form = this.formBuilder.group({
        email: ['', Validators.compose([Validators.required, Validators.pattern('^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$'), Validators.minLength(1)])]
      });
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit(): void {
      this.submitted = true;


      this.email=this.form.value.email

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        this.errorEncountered=false
        this.userService.sendPasswordLink(this.formData()).subscribe(
          rsData=>{

            let status =+rsData['status']
            let message =rsData['message']
            this.loading=false
            if(status==1){
              this.isRegistrationSuccess=true
            }else{
              this.isRegistrationSuccess=false

            }
            this.alertResponse(message)
          },
          err=>{
            this.loading=false
            this.responseMessage = err.error.message;
            this.isRegistrationSuccess=false
            this.errorEncountered=true
            this.alertResponse("Some thing went wrong")
          }
        )
  }


  reloadPage(): void {
    window.location.reload();
  }
  checkPasswords(){
    let isOk=true
    if(this.f.password.touched || this.f.passwordConfirmation.touched){
      isOk = this.f.password.value==this.f.passwordConfirmation.value
    }
    return isOk
  }

  formData(){
    let body = new URLSearchParams();
    body.set('email', this.email);

    return body.toString()
  }

  alertResponse(message:string){
    Swal.fire( 'Yes',message,'info')
    return
  }
}
